import { TeamStanding } from "../../../api/client/Api";
import { S3Image } from "../../../components/S3Image";

interface TeamsRankingProps {
  label: string;
  teams: TeamStanding[];
  pointLabel: string;
}

export const TeamsRanking = ({
  label,
  teams,
  pointLabel,
}: TeamsRankingProps) => {
  return (
    <div className="relative">
      <div className="bg-white shadow-md rounded-md overflow-hidden max-w-lg mx-auto mt-8 flex flex-col flex-1 w-full">
        <div className="bg-gray-200 py-2 px-4">
          <h2 className="text-xl font-semibold text-gray-800">{label}</h2>
        </div>
        <ul className="divide-y divide-gray-200">
          {teams?.map((item, index) => (
            <li key={item.team_id} className="flex items-center py-4 px-6">
              <span className="text-gray-700 text-lg font-medium mr-6">
                {index + 1}
              </span>
              {item.team_logo_key ?? "" ? (
                <S3Image
                  className="w-16 h-16 object-contain mr-4"
                  keyPath={item.team_logo_key ?? ""}
                  alt={item.team_name ?? ""}
                />
              ) : (
                <div className="w-16 h-16 mr-4 bg-gray-200 rounded-full" />
              )}
              <div className="flex-1">
                <h3 className="text-lg font-medium text-gray-800">
                  {item.team_name}
                </h3>
                <p className="text-gray-600 text-base">
                  {item.points}{" "}
                  {item.points && item.points > 1
                    ? pointLabel
                    : pointLabel.slice(0, -1)}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
